import { errorEnvelope } from "../../../../../global/js/errorCodes.js";
import { translateError } from "../errorTranslations.js";

export async function handleBackendResponse(response, fallbackErrorMessage) {
  const contentType = response.headers.get("Content-Type") || "";
  
  // PRIORITY 1: Turbo-stream (renderToast from backend)
  if (contentType.includes("turbo-stream")) {
    const html = await response.text();
    Turbo.renderStreamMessage(html); 
    
    // If response is not ok, backend already displayed the toast
    // Throw special marker error so caller knows not to show another toast
    if (!response.ok) {
      throw new Error("backend-error"); 
    }
    return { success: true, type: "toast" };
  }

  // PRIORITY 2: Redirect
  if (response.redirected || response.status === 302 || response.status === 303) {
    window.location.href = response.url;
    return { success: true, type: "redirect" };
  }

  // PRIORITY 3: JSON response
  if (contentType.includes("application/json")) {
    if (!response.ok) {
      // Migrated routes answer the coded envelope (COI-779); translateError
      // renders its localised copy, falls back to the server's message for a
      // code this app has no key for, and to fallbackErrorMessage for a legacy
      // body that carries neither.
      const errorData = await response.json().catch(() => null);
      const error = new Error(translateError(errorData, fallbackErrorMessage));
      const envelope = errorEnvelope(errorData);
      if (envelope) {
        error.code = envelope.code;
        error.requestId = envelope.requestId;
      }
      throw error;
    }
    const data = await response.json();
    return data;
  }

  // PRIORITY 4: HTML response
  if (contentType.includes("text/html")) {
    const html = await response.text();
    
    // Update content frame if present (for dynamic page updates)
    const contentFrame = document.getElementById("content");
    if (contentFrame) {
      contentFrame.innerHTML = html;
    }
    
    return { success: true, type: "html", html };
  }

  // FALLBACK: Unexpected response or server error
  if (!response.ok) {
    throw new Error(fallbackErrorMessage);
  }

  return { success: true };
}

